import { Box, HStack, VStack } from '@bpba/ui-components';
import { FC } from 'react';
import { Buscador } from './Buscador';
import { Logo } from './Logo';
import { BP_CONTAINER_PAD_X } from '../../constants/styles';
import { HOME_PATH } from '../home/Home';
import { UserPannel } from './UserPannel';
import { HeaderContainer } from './HeaderContainer';
import { NOMBRE_APLICACION } from '../../constants/data';
import { Login } from './Login';
import { Legales } from '../legales/Legales';
import { ModuleContainerGeneric } from '@bpba/modules-components';

export const Header: FC = () => {
  const homeUrl = `${process.env.PUBLIC_URL}${HOME_PATH}`;
  const logoAltText = `Logo del programa de premios ${NOMBRE_APLICACION}.`;

  return (
    <HeaderContainer position="fixed" width="100%" top="0" zIndex={3} flexDirection={'column'} backgroundImage="tertiary.gradient">
      {/* desktop */}
      <ModuleContainerGeneric backgroundColor={'tertiary.gradient'} paddingY={0} display={['none', null, null, 'flex']}>
        <Box paddingY={[20]} width={'100%'} flexDirection="row" justifyContent="space-between" alignItems="center" margin="auto">
          <Box width={'100%'}>
            <Logo linkUrl={homeUrl} altText={logoAltText} color={'white'} />
          </Box>
          <Buscador color={'white'} />
          <Box width={'100%'} justifyContent={'flex-end'}>
            <UserPannel color={'white'} />
            <Login color={'white'} />
          </Box>
        </Box>
      </ModuleContainerGeneric>

      {/* mobile */}
      <VStack display={['flex', null, null, 'none']}>
        <Box
          backgroundImage={'tertiary.gradient'}
          paddingX={BP_CONTAINER_PAD_X}
          paddingY={[20]}
          width="100%"
          flexDirection="column"
          alignItems="center"
          margin="auto"
        >
          <HStack alignItems={'center'} justifyContent={'space-between'}>
            <Logo linkUrl={homeUrl} altText={logoAltText} color={'white'} />
            <Buscador color={'white'} />
            <Login color={'white'} />
          </HStack>
          <UserPannel color={'white'} />
        </Box>
      </VStack>

      <Legales backgroundColor={'secondary.0'} />
    </HeaderContainer>
  );
};
